module.exports = __webpack_public_path__ + "img/progress-1.c5298d96.svg";